module.exports = __webpack_public_path__ + "static/img/4.6ad6138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/4.jpg
// module id = LTDO
// module chunks = 1